import { render, staticRenderFns } from "./GenerateAftercare.vue?vue&type=template&id=62bc2f19&"
import script from "./GenerateAftercare.vue?vue&type=script&lang=js&"
export * from "./GenerateAftercare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports